import { render, staticRenderFns } from "./MiniSmoothArea.vue?vue&type=template&id=a5d83fcc&scoped=true"
import script from "./MiniSmoothArea.vue?vue&type=script&lang=js"
export * from "./MiniSmoothArea.vue?vue&type=script&lang=js"
import style0 from "./MiniSmoothArea.vue?vue&type=style&index=0&id=a5d83fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d83fcc",
  null
  
)

export default component.exports